import { giphyBlack, giphyYellow } from '@giphy/js-brand'
import styled, { css } from 'styled-components'
import { ControlSize, Gradient } from 'types'
import {
    borderRadiusFromControlSize,
    brightnessFromColor,
    fontShadowFromControlSize,
    fontSizeFromControlSize,
    gradientToCss,
    heightFromControlSize,
    gradientToHexColors,
} from 'utils'
import LoaderComponent from '../../loader/blocks'

export const Label = styled.span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`

export const Icon = styled.span`
    display: inline-block;
    font-size: 0.9em;
    font-weight: normal;
    line-height: 1;
    vertical-align: middle;

    > i {
        display: inline-block;
        height: 1em;
        margin-top: 0.2em;
        width: 1em;
    }

    > svg {
        display: inline-block;
        flex-shrink: 0;
    }

    &:first-child {
        margin-right: 0.5em;
    }

    &:last-child {
        margin-left: 0.5em;
    }

    &:only-child {
        margin-left: 0;
        margin-right: 0;
    }
`

export const Button = styled.button<{
    controlColor: string
    controlSize: ControlSize
    dimmed: boolean
    disabled: boolean
    textColor?: string
    gradient?: Gradient
    iconGradient?: Gradient | undefined
}>`
    align-items: center;
    border: none;
    box-sizing: border-box;
    cursor: pointer;
    display: flex;
    font-weight: bold;
    justify-content: center;
    line-height: normal;
    user-select: none;

    &:active {
        opacity: 0.8;
    }

    &:focus-visible {
        outline: 2px solid ${giphyYellow};
    }

    ${({ controlColor, controlSize, dimmed, disabled, gradient, textColor, iconGradient }) => {
        const color = textColor || (brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff')

        return css`
            background: ${gradient ? gradientToCss(gradient) : controlColor};
            border-radius: ${borderRadiusFromControlSize(controlSize)}px;
            color: ${gradient ? textColor || '#fff' : color};
            font-size: ${fontSizeFromControlSize(controlSize)}px;
            height: ${heightFromControlSize(controlSize)}px;
            min-width: ${heightFromControlSize(controlSize)}px;
            padding: 0 1em;

            ${Label} {
                line-height: ${heightFromControlSize(controlSize)}px;
            }

            ${Icon} > svg {
                height: ${Math.round(heightFromControlSize(controlSize) * 0.4)}px;
                width: ${Math.round(heightFromControlSize(controlSize) * 0.5)}px;

                #gradient-stop-1 {
                    stop-color: ${iconGradient && gradientToHexColors(iconGradient)[0]};
                }
                #gradient-stop-2 {
                    stop-color: ${iconGradient && gradientToHexColors(iconGradient)[1]};
                }

                path {
                    fill: ${!iconGradient && color};
                }
            }

            ${dimmed &&
            css`
                opacity: 0.5;
            `}

            ${disabled &&
            css`
                pointer-events: none;
            `}
        `
    }}

    ${({ controlSize, gradient }) =>
        gradient &&
        css`
            > span {
                filter: drop-shadow(${fontShadowFromControlSize(controlSize)});
            }
        `}
`

export const Loader = styled(LoaderComponent)``
